import { RootState } from "../store/root-reducer";

const pickedCountriesSelector = (state: RootState) => state.pick.countries;
const pickedCriteriaSelector = (state: RootState) => state.pick.criteria;

export { pickedCountriesSelector, pickedCriteriaSelector };
